
import { useMutation } from "react-query";
import axios from "axios";
import { useDispatch } from "react-redux";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { USER_MESSAGE } from "../../../actions/User";


const mutatePostDate = async ({ data }) => {
    let apiUrl = `${config.ENDPOINTS["main"]}/user/registration`;
    // Clone the object to avoid direct modification of the original object, to match whats in the DB
    const modifiedData = { ...data, group: data?.group?.toLowerCase() };
    console.log(modifiedData);
    const response = await axios.post(apiUrl, modifiedData,
        {
            headers: setHeaders()
        });
    if (!response?.data) {
        throw new Error('Network response was not ok');
    }
    return response?.data;
};



const useMutateRegisration = () => {
    const dispatch = useDispatch();
    const mutation = useMutation(mutatePostDate, {
        mutationKey: 'registration',
        onSuccess: (data) => {
            dispatch({
                type: USER_MESSAGE,
                msgType: "success",
                text: "Regsitration dispatched for approval",
                key: crypto.randomUUID()
            });
        },
        onError: (error) => {
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: error?.response?.data?.data?.message || "Error registering user",
                key: crypto.randomUUID()
            });
        },
    });

    return mutation;
}

export default useMutateRegisration;